module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Primary Language":"Primary Language"},"es":{"Primary Language":"Lenguaje Primario"},"sw":{"Primary Language":"Lugha Msingi"}}')
  delete Component.options._Ctor
}
